module.exports = __webpack_public_path__ + "static/media/trash.3a77af5b.svg";